import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Heading,
    Stack,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {optionEntryTypes, options} from './Options'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import './RichTextComponent.scss'

const RichTextComponent = ({
    data,
    alignItems = 'center',
    textAlign = 'left',
    gap = {base: '18px', lg: '30px'},
    width = {base: '100%', lg: '50%'},
    paddingLeft = {base: '17px', lg: '20px'},
    paddingRight = {base: '50px', lg: '80px'}
}) => {
    const assets = {
        block: (data?.content?.content ?? [])
            ?.filter(
                ({nodeType}) => nodeType === optionEntryTypes.embeddedAssetBlock
            )
            .map(({data}) => ({
                ...data?.target?.fields?.file,
                sys: data?.target?.sys
            }))
    }

    return (
        <Stack
            gap={gap}
            width={width}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            marginY={{base: '0', lg: 'auto'}}
        >
            <Flex flexDirection="column" alignItems={alignItems} gap="30">
                <Flex flexFlow="column" alignItems={alignItems}>
                    {data?.heading && (
                        <Heading
                            as={data?.headingType || 'h2'}
                            fontSize={{base: '25px', lg: '55px'}}
                            fontFamily="Raleway"
                            fontWeight="300"
                            textAlign={textAlign}
                        >
                            {data?.heading}
                        </Heading>
                    )}
                    {data?.subTitle && (
                        <Heading
                            fontSize={{base: '25px', lg: '55px'}}
                            lineHeight={{base: '29px', lg: '70px'}}
                            fontFamily="Raleway"
                            fontWeight="300"
                            textAlign={textAlign}
                        >
                            {data?.subTitle}
                        </Heading>
                    )}
                    {data?.description && (
                        <Text
                            fontSize={{base: '25px', lg: '55px'}}
                            lineHeight={{base: '29px', lg: '70px'}}
                            fontFamily="Raleway"
                            fontWeight="300"
                            textAlign={textAlign}
                        >
                            {data?.description}
                        </Text>
                    )}
                </Flex>
                {data?.content && (
                    <Flex
                        className="Paragraph__div"
                        alignItems={alignItems}
                        justifyContent={alignItems}
                        textAlign={textAlign}
                        fontSize={{base: '12px', lg: '24px'}}
                        lineHeight={{base: '14px', lg: '32px'}}
                        fontFamily="Raleway"
                        fontWeight="400"
                    >
                        {documentToReactComponents(
                            data?.content,
                            options({
                                aspectRatio: false,
                                entries: {
                                    inline:
                                        data?.content?.links?.entries?.block ??
                                        []
                                },
                                assets
                            })
                        )}
                    </Flex>
                )}
            </Flex>
        </Stack>
    )
}

RichTextComponent.propTypes = {
    sectionName: PropTypes.string,
    data: PropTypes.object,
    alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
    textAlign: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
    gap: PropTypes.object,
    width: PropTypes.object,
    paddingLeft: PropTypes.object,
    paddingRight: PropTypes.object
}

export default RichTextComponent
